import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import { coloBlindnessOption } from './formOptions'
import RadioButtonController, { CheckBoxLikeRadio } from '../../../../components/RadioButtonController/RadioButtonController'
import { ParentContainerSection } from '../DiabeticForm'

const ColorBlindTest = (props) => {
    const { control, errors } = props

    const colorBlindTest=[
        {label:"L", formFieldName:"color_blindness_left", option: coloBlindnessOption },
        {label:"R", formFieldName:"color_blindness_right", option: coloBlindnessOption },
    ]

  return (
    <ParentContainerSection heading={"Section E: Color Blindness Test"}>  

        <TableContainer component={Paper} sx={{ maxWidth: 350, mb: "1rem" }}>
      <Table sx={{maxWidth:350, '& td, & th': { border: '0.5px solid lightgray', padding:"0px" } }} aria-label="color blind table">
        <TableHead>
          <TableRow >
            <TableCell sx={{width:"20px"}} rowSpan={2}></TableCell>
            <TableCell sx={{width:"20px"}} align="center">None</TableCell>
            <TableCell sx={{width:"20px"}}  align="center">Red/Green</TableCell>
            <TableCell sx={{width:"20px"}} align="center">Blue/Yellow</TableCell>
            <TableCell sx={{width:"20px"}} align="center">Complete</TableCell>
            
          </TableRow>
        </TableHead>
        <TableBody>
        {colorBlindTest.map((blindRow,index)=>(
            <TableRow key={index}>
            <TableCell align="center" sx={{minWidth:"20px"}}>{blindRow.label}</TableCell>
            {blindRow.option.map((item, optionInd)=>(
                <TableCell align="right" key={optionInd}>
                <CheckBoxLikeRadio 
                                name={blindRow.formFieldName}
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={[item]}
                                isMargin={false}
                                isDisabled={true}
                            />
                            </TableCell>
            ))}
          </TableRow>
        ))}
        </TableBody>
      </Table>
    </TableContainer>
    </ParentContainerSection>
  )
}

export default ColorBlindTest